<template>
  <div class="top_ad"
       v-if="bannerList && bannerList.length > 0">
    <Carousel :autoplay="bannerList.length > 1"
              loop
              dots="none"
              arrow="never"
              :autoplay-speed="5000">
      <CarouselItem v-for="(item, index) in bannerList"
                    :key="index">
        <a :href="item.linkValue"
           target="_blank">
          <img style="width: 100%; height: 100%;max-height:60px;"
               :src="common.showPic(item.adPic)"
               :alt="item.adName"
               :title="item.adName"
               :onerror="common.defaultImg()"
               @click="clickAdv(item.id)">
        </a>
      </CarouselItem>
    </Carousel>
  </div>
</template>

<script>
import { getBannerList, clickAdvert } from '@/api/index'

export default {
  name: 'TopAd',
  data () {
    return {
      bannerList: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 获取最顶层广告
    init () {
      getBannerList({ adPositionTypes: '1001' }).then(res => {
        this.bannerList = res.data.list
      })
    },
    // 点击广告提交统计数据
    clickAdv (id) {
      clickAdvert({ adId: id })
    }
  }
}
</script>

<style lang="less" scoped>
.top_ad {
  min-width: 1200px;
  font-size: 0;
  a {
    width: 100%;
    height: 100%;
  }
  img {
    display: block;
    width: 100%;
    height: 50px;
    object-fit: contain;
  }
}
</style>
